module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/zh-hant/4-905bf06a9f7975570885670077d6d7dc.jpg";